import {Component, OnInit} from '@angular/core';
import {FoldersService} from '../../../../../core/ek-e-commerce/ek-services/folders.service';
import {CountFolderState} from '../../../../../core/ek-e-commerce/ek-models/count-statistics.model';
import {BehaviorSubject} from 'rxjs';
import {ClientsListPopUpComponent} from '../folders/clients-list-pop-up/clients-list-pop-up.component';
import {MatDialog} from '@angular/material/dialog';
import {MenuConfigService} from '../../../../../core/_base/layout';
import {FOLDER_STATES} from '../../Shared/Constants/folderStates';

export interface FolderSummary {
    folderState: string;
    totalCount: number;
    total: number | string; // to accommodate "NaN" as string
}

export interface FoldersStatistics {
    name: string;
    color: string;
    totalCount: number;
    totalAmount: number;
}

@Component({
    selector: 'kt-order-statistics',
    templateUrl: './order-statistics.component.html',
    styleUrls: ['./order-statistics.component.scss']
})
export class OrderStatisticsComponent implements OnInit {


    statisticsSubject$ = new BehaviorSubject<FolderSummary[]>(null);
    countStatistics$ = this.statisticsSubject$.asObservable();

    foldersStatisticsSubject$ = new BehaviorSubject<FoldersStatistics[]>(null);
    foldersStatistics$ = this.foldersStatisticsSubject$.asObservable();

    diameter = 200;
    foldersSubject$: BehaviorSubject<CountFolderState[]> = new BehaviorSubject<CountFolderState[]>([]);
    currentRole = '';

    constructor(private folderService: FoldersService, public dialog: MatDialog, private menuConfigService: MenuConfigService) {
        this.currentRole = JSON.parse(localStorage.getItem('currentUser')).roles;
    }

    ngOnInit(): void {

        this.menuConfigService.statisticsSubject$.subscribe((data) => {
            this.foldersSubject$.next(data);
        });


        this.folderService.FoldersStatisticsWithTotal().subscribe({
            next: (res) => {
                if (res) {
                    const convertedResponse = this.convertToFoldersStatistics(res);
                    this.foldersStatisticsSubject$.next(convertedResponse);
                } else {
                    this.foldersStatisticsSubject$.next(null);
                }
            }
        });

    }

    sortFolderDataByOrder(
        data: FolderSummary[],
    ): FolderSummary[] {
        const orderMap = new Map<string, number>(
            FOLDER_STATES.map(state => [state.value, state.order])
        );

        return [...data].sort((a, b) => {
            const orderA = orderMap.get(a.folderState) ?? Infinity;
            const orderB = orderMap.get(b.folderState) ?? Infinity;
            return orderA - orderB;
        });
    }

    convertToFoldersStatistics(data: any): FoldersStatistics[] {

        if (!data) {
            return;
        }

        const result: FoldersStatistics[] = [];

        const labelMap: Record<string, string> = {
            caPrevisionnel: 'CA Prévisionnel',
            caPotentiel: 'CA Potentiel',
            caEngage: 'CA Engagé',
            caEncaisse: 'CA Encaissé',
        };

        const colorMap: Record<string, string> = {
            caPrevisionnel: '#ffcc43',
            caPotentiel: '#f39c12',
            caEngage: '#009dcc',
            caEncaisse: '#58d68d',
        };

        // Convert the main CA categories
        const categories = ['caPrevisionnel', 'caPotentiel', 'caEngage', 'caEncaisse'];
        for (const key of categories) {
            if (data[key]) {
                result.push({
                    name: labelMap[key] || key,
                    color: colorMap[key] || '#58d68d',
                    totalCount: data[key].totalCount,
                    totalAmount: parseFloat(data[key].totalAmount.replace(/[^0-9.-]+/g, '')),
                });
            }
        }

        const yearColorMap: Record<string, string> = {
            '2023': '#ffcc43',
            '2024': '#85929e',
            '2025': '#58855C',
            '2026': '#5746f6',
            '2027': '#85929e',
        };

        // Convert acceptedFoldersByYear
        if (Array.isArray(data.acceptedFoldersByYear)) {
            for (const folder of data.acceptedFoldersByYear) {
                result.push({
                    name: `Dossiers acceptés ${folder.year}`,
                    color: yearColorMap[folder.year] || '#009dcc',
                    totalCount: folder.totalCount,
                    totalAmount: parseFloat(folder.totalAmount.replace(/[^0-9.-]+/g, '')),
                });
            }
        }

        return result;
    }

    openClientPopUp() {
        this.dialog.open(ClientsListPopUpComponent, {
            width: '92rem',
        });
    }

}
